// extracted by mini-css-extract-plugin
export var layout = "index-module--layout--a709a";